/* ============================================================
   CDS Form Confirmation — popup global cross-page
   ============================================================
   Probleme : un formulaire Shopify peut rediriger n'importe ou apres
   submit (selon la config du site). La cliente clique "Envoyer" et
   se retrouve sur la home sans confirmation visuelle. Doute sur le
   fait que sa demande soit bien partie.

   Solution : avant le submit, on flag dans sessionStorage. Sur la
   page suivante (peu importe laquelle), un script global lit le flag
   et affiche un popup de confirmation. Le flag est efface apres lecture.

   API publique :
     window.CDSFormConfirmation.markSent(options)
       - options.title    (string)  - titre de la popup
       - options.message  (string)  - message principal
       - options.icon     (string)  - emoji ou symbole (default: ✓)

   Usage typique :
     form.addEventListener('submit', function() {
       CDSFormConfirmation.markSent({
         title: 'Demande envoyée !',
         message: 'Nous reviendrons vers toi sous 24-48h.'
       });
     });
*/
(function() {
  var STORAGE_KEY = 'cds_form_confirmation_pending';
  var CONSUMED_KEY = 'cds_form_confirmation_consumed';
  var TTL_MS = 30 * 1000; // valide 30s apres le submit (au-dela : popup ne s'affiche plus)

  function isAvailable() {
    try {
      var t = '__cds_test__';
      window.sessionStorage.setItem(t, '1');
      window.sessionStorage.removeItem(t);
      return true;
    } catch (e) { return false; }
  }

  function markSent(options) {
    if (!isAvailable()) return;
    var payload = {
      title: (options && options.title) || 'Demande envoyée !',
      message: (options && options.message) || 'Nous avons bien reçu ta demande.',
      icon: (options && options.icon) || '✓',
      ts: Date.now()
    };
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      /* Reset le flag "consumed" pour cette nouvelle soumission (sinon une
         ancienne valeur "consumed" pourrait empecher l'affichage de la popup
         pour ce nouveau submit) */
      window.sessionStorage.removeItem(CONSUMED_KEY);
    } catch (e) {}
  }

  function consumePending() {
    if (!isAvailable()) return null;
    var raw;
    try { raw = window.sessionStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
    if (!raw) return null;
    var data;
    try { data = JSON.parse(raw); } catch (e) { return null; }
    if (!data || !data.ts) return null;
    /* TTL : si trop ancien, on nettoie ET on retourne null. */
    if (Date.now() - data.ts > TTL_MS) {
      try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      return null;
    }
    /* Anti-doublon : si on a deja consume CE timestamp precis, on ne ré-affiche
       pas la popup (cas iOS Safari ou removeItem peut etre ignore silencieusement) */
    var consumedTs = null;
    try { consumedTs = window.sessionStorage.getItem(CONSUMED_KEY); } catch (e) {}
    if (consumedTs && String(consumedTs) === String(data.ts)) return null;
    /* Marque comme consume + tente la suppression du flag principal */
    try {
      window.sessionStorage.setItem(CONSUMED_KEY, String(data.ts));
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
    return data;
  }

  function showPopup(data) {
    /* Build DOM */
    var overlay = document.createElement('div');
    overlay.className = 'cds-confirm-popup';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'cds-confirm-title');

    overlay.innerHTML = '<div class="cds-confirm-popup__backdrop" data-confirm-close></div>'
      + '<div class="cds-confirm-popup__box">'
      +   '<div class="cds-confirm-popup__icon" aria-hidden="true">' + escapeHtml(data.icon || '✓') + '</div>'
      +   '<h3 class="cds-confirm-popup__title" id="cds-confirm-title">' + escapeHtml(data.title) + '</h3>'
      +   '<p class="cds-confirm-popup__message">' + escapeHtml(data.message) + '</p>'
      +   '<div class="cds-confirm-popup__actions">'
      +     '<button type="button" class="cds-confirm-popup__btn" data-confirm-close>Compris</button>'
      +     '<button type="button" class="cds-confirm-popup__btn cds-confirm-popup__btn--secondary" data-confirm-new>Nouvelle demande</button>'
      +   '</div>'
      + '</div>';

    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';

    requestAnimationFrame(function() { overlay.classList.add('is-visible'); });

    function close() {
      overlay.classList.remove('is-visible');
      document.documentElement.style.overflow = '';
      setTimeout(function() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 250);
      window.removeEventListener('keydown', onKey);
    }
    function newDemande() {
      /* Force le clear du sessionStorage et recharge la page (reset le formulaire).
         Utile si la cliente est restee bloquee avec la popup. */
      try {
        window.sessionStorage.removeItem(STORAGE_KEY);
        window.sessionStorage.removeItem(CONSUMED_KEY);
      } catch (e) {}
      window.location.reload();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    overlay.addEventListener('click', function(e) {
      if (e.target.closest('[data-confirm-new]')) { newDemande(); return; }
      if (e.target.closest('[data-confirm-close]')) close();
    });
    window.addEventListener('keydown', onKey);
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = String(str == null ? '' : str);
    return d.innerHTML;
  }

  function init() {
    var data = consumePending();
    if (data) showPopup(data);
  }

  /* Public API */
  window.CDSFormConfirmation = {
    markSent: markSent
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
